module.exports = __webpack_public_path__ + "img/NAA-logo.e3fdfb64.svg";